import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_widget-studio-19/artifacts/cfszi269_Firefly_Use%20teh%20clean%20one%20from%20this%20set%20and%20change%20Widgets%20%26%20AI%20Solutions%20to%20AI%20Driven%20Innova%2050267.png";

export const Footer = () => {
  return (
    <footer className="border-t border-subtle py-12 px-4 sm:px-6 lg:px-8" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-5 md:space-y-0">
          <div className="riveted-frame mb-4 inline-block">
            <div className="h-12 w-40 overflow-hidden rounded-[10px]">
              <img
                src={LOGO_URL}
                alt="LAB21g Logo"
                className="w-full h-full object-cover"
                style={{ objectPosition: 'center 60%' }}
              />
            </div>
          </div>
          <p className="text-sm text-muted" data-testid="footer-copyright">
            © 2026 lab21g.com — Build. Automate. Train.
          </p>
        </div>
      </div>
    </footer>
  );
};
